import styled, { css } from 'styled-components';

import Help from 'ggApp/shared/icons/help';

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LineWrap = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
`;

export const Paragraph = styled.p`
    ${({ theme }) => css(theme.typography.Paragraph)}
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const HelpIconWrap = styled.div`
    height: 16px;
    width: 16px;
    margin: 0 auto 0 4px;
    align-self: center;
`;

export const HelpIcon = styled(Help)``;

export const SummaryWrap = styled(LineWrap)`
    margin: 12px 0 16px;
    align-items: center;
`;

export const SummaryText = styled.p`
    ${({ theme }) => css(theme.typography.SmallHeadline)}
    color: ${({ theme }) => theme.colors.Foreground};

    span:last-child {
        ${({ theme }) => css(theme.typography.TinyParagraph)}
        line-height: 29px;
        margin-left: 8px;
    }
`;

export const ToolTipWrap = styled.div`
    display: flex;
    align-items: center;
`;
